try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import { Link } from '@design-system/link';
import classNames from 'classnames';
import { forwardRef } from 'react';

const SearchInput = forwardRef(({ className, placeholder, onKeyDown, inputRef, searchPageUrl, autocomplete, LinkComponent = Link, }, ref) => {
    var _a;
    return (jsxs("div", Object.assign({ ref: ref, className: classNames('cds-search-input', className) }, { children: [jsx("input", Object.assign({ ref: inputRef, className: "cds-search-input__textfield", placeholder: placeholder, onKeyDown: onKeyDown }, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
                placeholder,
                onKeyDown,
            }))), ((_a = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.autocompleteState) === null || _a === void 0 ? void 0 : _a.isOpen) &&
                (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.autocompleteState.collections.map(({ items }) => (jsx("ul", Object.assign({ className: "cds-search-input__autocomplete" }, { children: items.map((item) => (jsx(LinkComponent, Object.assign({ className: "cds-search-input__autocomplete-item", href: `${searchPageUrl}?q=${item.label}`, variant: "nav" }, { children: item.label }), item.label))) })))))] })));
});

export { SearchInput };
